import { Splide } from "@splidejs/splide";

export class Sliders {
  constructor() {
    this.init();
  }

  init() {
    const sliderWrappers = document.querySelectorAll(".slider.splide");

    sliderWrappers.forEach((sliderWrapper) => {
      this.createSlider(sliderWrapper);
    });
  }

  createSlider(sliderWrapper) {
    const i18n = this.getI18nConfig();
    let autoplay = true;
    let interval = 5000;
    let splideToggle;

    // Handle autoplay configuration
    if (sliderWrapper.dataset.autoplay === "false") {
      autoplay = false;
    } else {
      interval =
        sliderWrapper.dataset.autoplay !== undefined
          ? parseInt(sliderWrapper.dataset.autoplay)
          : 5000;

      splideToggle = this.createPlayPauseToggle();
      sliderWrapper.appendChild(splideToggle);
    }

    // Create Splide instance
    const splide = new Splide(sliderWrapper, {
      type: "loop",
      perPage: 1,
      pagination: true,
      arrows: false,
      flickMaxPages: 0.3,
      i18n,
      autoplay,
      pauseOnHover: false,
      interval,
    });

    // Setup play/pause button after mount
    if (autoplay && splideToggle) {
      splide.on("mounted", () => {
        const pagination = sliderWrapper.querySelector(".splide__pagination");
        if (pagination) {
          pagination.insertAdjacentElement("afterbegin", splideToggle);
        }
      });
    }

    splide.mount();
  }

  createPlayPauseToggle() {
    const splideToggle = document.createElement("li");
    splideToggle.classList.add("splide__toggle");
    splideToggle.setAttribute("role", "presentation");

    const splideToggleButton = document.createElement("button");
    splideToggleButton.classList.add("splide__toggle__button");
    splideToggleButton.setAttribute("type", "button");
    splideToggle.setAttribute("role", "tab");
    splideToggleButton.setAttribute("aria-label", "Play/pause");

    const splideTogglePlay = document.createElement("span");
    splideTogglePlay.classList.add("splide__toggle__play");
    splideTogglePlay.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 12L7 1V23L24 12Z"/></svg>';

    const splideTogglePause = document.createElement("span");
    splideTogglePause.classList.add("splide__toggle__pause");
    splideTogglePause.innerHTML =
      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="2" width="4" height="20"/><rect x="15" y="2" width="4" height="20"/></svg>';

    splideToggle.appendChild(splideToggleButton);
    splideToggleButton.appendChild(splideTogglePlay);
    splideToggleButton.appendChild(splideTogglePause);

    return splideToggle;
  }

  getI18nConfig() {
    const isEnglish = document.documentElement.lang === "en";

    return isEnglish
      ? {
          prev: "Previous slide",
          next: "Next slide",
          select: "Select a slide to show",
          slideX: "Go to slide %s",
          carousel: "Slideshow",
          slide: "Slide",
          slideLabel: "%s of %s",
        }
      : {
          prev: "Vorheriger Slide",
          next: "Nächster Slide",
          select: "Wähle einen Slide aus",
          slideX: "Gehe zu Slide %s",
          carousel: "Slideshow",
          slide: "Slide",
          slideLabel: "%s von %s",
        };
  }
}
